import * as types from './types';
import createReducer from '../../utils/createReducer';

import initialState from './initialState';

const reducersMap = {
   [types.FETCH_DOMAIN_START]: (state) => {
      return {
         ...state,
         isFetching: true,
         pointCustomDomain: {},
      }
   },
   [types.FETCH_DOMAIN_COMPLETED]: (state, action) => {
      return {
         ...state,
         isFetching: false,
         data: action.payload,
      };
   },

   [types.FETCH_DOMAIN_FAILED]: (state) => {
      return {
         ...state,
         isFetching: false,
      };
   },
   [types.UPDATE_DATA_COMPLETED]: (state, action) => {
      return {
         ...state,
         data: {
            ...state.data,
            ...action.payload,
         },
      };
   },
   [types.POINT_DOMAIN_COMPLETED]: (state, action) => {
      return {
         ...state,
         pointCustomDomain: action.payload,
      };
   },
   [types.CHANGE_DOMAIN_STATUS_COMPLETED]: (state, action) => {
      return {
         ...state,
         domain_has_completed: action.payload,
      };
   },
};

export default createReducer(initialState)(reducersMap);
